import { CASES } from "./constants";

/**
 * Updates licensing job-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the licensingJobs slice
 */
export const updateJobs = (payload) => {
  return { type: CASES.UPDATE_JOBS, payload };
};

/**
 * Updates a specific field in the licensing jobs search form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'filterForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateJobsSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_JOBS_SEARCH_FORM,
    payload: { key, data },
  };
};

/**
 * Updates a specific field in the licensing job create/edit form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'licensingJobForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateJobsForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_JOBS_FORM,
    payload: { key, data },
  };
};

/**
 * Resets the licensing jobs state to initial values, preserving sort preference.
 */
export const clearJobs = () => {
  return { type: CASES.CLEAR_JOBS, payload: {} };
};

/**
 * Resets the job view modal state including tasks and selected job.
 */
export const clearJobViewModal = () => {
  return { type: CASES.CLEAR_JOB_VIEW_MODAL, payload: {} };
};

/**
 * Clears only the selected job reference, preserving other modal state.
 */
export const clearJobTasksModal = () => {
  return { type: CASES.CLEAR_JOB_TASKS_MODAL, payload: {} };
};
